
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { CustomerMeterDetails, Store, } from '~/apps/account/store';
import { OutsideClick, } from '~/directives/outside-click';
import type { Result, } from '~/utils/models/result';
import { getServiceName, } from '~/utils/service-name';
@Component({
	components: {
	},
	directives: {
		OutsideClick,
	},
})
export default class AccountNavLinks extends Vue {
    @Prop({ type: String, required: false, })
	moveOutDate!: string | null;

    @Prop({ type: String, required: false, })
	paymentMethod!: string | null;

    @Prop({ required: true, })
	meterDetail!: Result<CustomerMeterDetails[]>;

    @Prop({ required: false, })
    homePageLocation!: string;

    @Prop({ type: Function, required: false, })
    handleViewProfileClick!: () => void;

    @Prop({ type: Array, required: false, default: () => [], })
	customerPropertyDetailList!: [];

    selectedNavItem: null | string = null;
    isSubMenuOpen = false;

    MYPAYMENTS = 'My payments';
    MYBILLS = 'My bills';
    MANAGEACCOUNT = 'Manage account';
    activeMenu: null | string = null;

    myPaymentsSubLinks = ['PayBillChooseAmount', 'DirectDebitDetails', 'SubmitMeterReadingYourReading',];
    myBillsSubLinks = ['AccountStatement', 'PaymentHistory', 'BillingHistory', 'WaterUsage', 'ViewCorrespondence',];
    manageAccountSubLinks = ['ViewProfile', 'PaperlessPreference', 'TellUsYourMoving',];

    /* eslint-disable no-mixed-spaces-and-tabs */
    get isPropertyActive() {
    	return Store.state.switchAccountDetails.state === 'completed' ? Store.state.switchAccountDetails.result.find((item) => item.conractAccountId === this.selectContractAccount)?.isPropertyActive : null;
    }

    get selectContractAccount() {
    	return Store.state.selectContractAccount;
    }

    get serviceProvided() {
    	return Store.state.contractPropertyDetails.state === 'completed' ? getServiceName(Store.state.contractPropertyDetails.result.customerServiceFlag) : '';
    }

    get selectedContractAccountSmStatus() {
	    return Store.state.selectedContractAccountSmStatus;
    }

    mounted() {
    	this.$router?.afterEach((to) => {
    		this.isSubMenuOpen = false;
    		if (this.myPaymentsSubLinks.includes(to.name as string)) {
    			this.activeMenu = this.MYPAYMENTS;
    		} else if (this.myBillsSubLinks.includes(to.name as string)) {
    			this.activeMenu = this.MYBILLS;
    		} else if (this.manageAccountSubLinks.includes(to.name as string)) {
    			this.activeMenu = this.MANAGEACCOUNT;
    		} else {
    			this.activeMenu = null;
    		}
    	});
    }

    toggleNavigation(selectedNavItem?: string) {
    	const selectedText = this.selectedNavItem === selectedNavItem;
    	if (selectedText) {
    		this.isSubMenuOpen = !this.isSubMenuOpen;
    	} else {
    		this.isSubMenuOpen = false;
    		this.selectedNavItem = selectedNavItem as string;
    		this.isSubMenuOpen = !this.isSubMenuOpen;
    	}
    }

    handleOpenNavMenu() {
    	if (this.isSubMenuOpen === true) {
    		this.isSubMenuOpen = false;
    		this.selectedNavItem = null;
    	}
    }
    /* eslint-disable no-mixed-spaces-and-tabs */
}
